<template>
  <div style="display: contents">
    <div class="meeting-left-top row-container ">
      <div class="row-left" style="">
        <h2 class="white--text">Dagordning</h2>
      </div>
      <div class="row-icon">
        <create-agenda-item :meetingId="meeting.id"></create-agenda-item>
      </div>
    </div>
    <div v-if="meeting.agenda.length > 0" class="meeting-left-content">
      <v-card
        v-for="item in agendaItems"
        :key="item.uid"
        :class="[activeAgenda === item.id ? '' : 'background--transparent']"
        style="margin-bottom: 12px; margin-right: 4px;"
      >
        <v-card-title class="subtitle-2" style="word-break: break-word;">
          <div class="agenda-item-container">
            <div class="agenda-item-text">{{ item.id }}. {{ item.text }}</div>

            <div class="agenda-item-icon">
              <edit-agenda-item
                :meeting="meeting"
                :agenda="item"
                :id="item.uid"
              ></edit-agenda-item>
            </div>
          </div>
        </v-card-title>

        <v-card-text
          v-if="item.attachment"
          style="padding-top: 0; padding-bottom: 8px;"
        >
          <a
            :href="item.attachment"
            target="_blank"
            style="text-decoration: none;"
          >
            <v-chip small>
              <v-icon left small>mdi-paperclip</v-icon>
              {{ getAttachmentName(item.attachment) }}
            </v-chip>
          </a>
        </v-card-text>

        <v-card-actions style="padding: 0;">
          <v-btn
            v-if="isOpen && activeAgenda !== item.id"
            text
            @click="activateAgenda(item)"
          >
            Aktivera
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <div v-else class="meeting-left-content">
      <v-card
        light
        style="margin-bottom: 12px;margin-right: 4px; padding: 12px"
        class="white"
        v-if="hasStandardAgendas"
      >
        <v-select
          class="white--text"
          v-model="agendaSelect"
          :items="Object.keys(standardAgendas)"
          label="Importera dagordning"
        ></v-select>
        <v-btn text @click="fillAgenda">Importera</v-btn>
      </v-card>
      <div v-else class="white--text">
        Inga dagordningspunkter inlagda.
      </div>
    </div>
  </div>
</template>

<script>
import CreateAgendaItem from "@/components/agenda/CreateAgendaItem.vue";
import EditAgendaItem from "@/components/agenda/EditAgendaItem.vue";

const collator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base"
});

export default {
  props: {
    meeting: Object,
    isOpen: Boolean
  },
  data() {
    return {
      agendaSelect: null
    };
  },
  components: {
    CreateAgendaItem,
    EditAgendaItem
  },
  computed: {
    activeAgenda() {
      return this.$store.getters["meetings/getState"].activeAgendaId;
    },
    agendaItems() {
      return this.meeting.agenda.concat().sort((a, b) => {
        return collator.compare(a.id, b.id);
      });
    },
    standardAgendas() {
      let selectedContract = this.$store.getters["contracts/contract"](
        this.meeting.contractId
      );
      if (selectedContract && selectedContract.standardAgendas) {
        return selectedContract.standardAgendas;
      } else {
        return {};
      }
    },
    hasStandardAgendas() {
      return Object.keys(this.standardAgendas).length > 0;
    }
  },
  methods: {
    getAttachmentName(attachmentUrl) {
      if (!attachmentUrl) return "";
      const parts = attachmentUrl.split("/");
      const fileName = parts[parts.length - 1];
      const decoded = decodeURIComponent(fileName.split("?")[0]);
      const withoutUid = decoded.replace(/^[^_]+_/, "");
      return withoutUid;
    },
    activateAgenda(item) {
      const agenda = {
        meetingId: this.meeting.id,
        id: item.id
      };
      this.$store.dispatch("meetings/activateAgendaItem", agenda);
    },
    fillAgenda() {
      let selectedAgenda = this.standardAgendas[this.agendaSelect];
      if (selectedAgenda) {
        this.$store.dispatch("meetings/importStandardAgenda", {
          meetingId: this.meeting.id,
          agenda: selectedAgenda
        });
      }
    }
  }
};
</script>

<style>
.agenda-item-container {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 24px;
  grid-template-rows: 1fr;
  grid-template-areas: "agenda-item-text agenda-item-icon";
}

.agenda-item-icon {
  grid-area: agenda-item-icon;
}
.agenda-item-text {
  grid-area: agenda-item-text;
}
</style>
